/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Capability_Sovereign_Body_2Inputs */

const en_landing_capability_sovereign_body_2 = /** @type {(inputs: Landing_Capability_Sovereign_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whatever model your teams use, your IP stays separate from any provider's public model or training pipeline. Never exposed, never used to train.`)
};

/**
* | output |
* | --- |
* | "Whatever model your teams use, your IP stays separate from any provider's public model or training pipeline. Never exposed, never used to train." |
*
* @param {Landing_Capability_Sovereign_Body_2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_capability_sovereign_body_2 = /** @type {((inputs?: Landing_Capability_Sovereign_Body_2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Capability_Sovereign_Body_2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_capability_sovereign_body_2(inputs)
});